import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { publishProducts } from 'src/api/publishProducts/publishProducts';
import { IPublishProductsRequestBody } from 'src/api/publishProducts/types';

type Options = Omit<UseMutationOptions<any, unknown, IPublishProductsRequestBody, unknown>, 'mutationFn'>;

export const usePublishProducts = (options: Options = {}) => {
  return useMutation((payload: IPublishProductsRequestBody) => publishProducts(payload), options);
};
